import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core'

import { NotificationMessage } from '../../notification-message.model'
import { AuthService } from '@app/modules/auth/auth.service'
import { TeamType } from '@shared/models/team.model'
import dayjs from 'dayjs'

@Component({
  selector: 'lin-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NotificationComponent {
  manuallyRead = false
  link: null | string

  private user = this.authService.getCurrentUser()

  private _notification: NotificationMessage

  @Input()
  set notification(notification: NotificationMessage) {
    this._notification = notification
    this.setLink()
  }

  get notification(): NotificationMessage {
    return this._notification
  }

  @Input() isRead = false

  @Output() markRead = new EventEmitter<string>()

  @HostBinding('class.is-read')
  get hasReadClass() {
    return this.manuallyRead || this.isRead
  }

  constructor(private authService: AuthService) {}

  markAsRead(): void {
    if (this.manuallyRead || this.isRead) return

    this.manuallyRead = true
    this.markRead.emit(this.notification.id)
  }

  handleLink(): void {
    this.markAsRead()
    this.link && window.open(this.link, '_blank')
  }

  private setLink(): void {
    const event = this.notification?.event
    const entityTeam = event?.entityTeam

    // v3 WebAlert has no numeric eventId (Q12) and entityTeam may lack `type` — hide the link instead
    // of building a broken /events-log/null URL (also guards a missing/malformed event object).
    if (!event || !entityTeam || event.eventId == null) {
      this.link = null
      return
    }

    const rootPath: string = this.user.isAdmin() ? 'admin' : 'client'
    const occurrenceTimeInMs = dayjs(this.notification.occurrenceTime).valueOf()

    this.link = `${rootPath}/alerts/events-log-details/events-log/${event.eventId}?eventTeam=${entityTeam.type}&occurrenceTime=${occurrenceTimeInMs}&eventLogId=${event.eventLogId}`
  }
}
